import * as Yup from 'yup';
import DOMPurify from 'dompurify';
import { getTemplateFormGridColumnSpan } from '../../../utils/templateFormGridUtil';
import { TemplateFormHelperText } from '../../TemplateFormHelperText';
import { TemplateFormComponentMeta } from '../../../interfaces/template-form-component-meta';
import { TemplateFormFieldValidationsFactory } from '../../../factories/templateFormFieldValidationFactory';
import { TemplateFormFilePickerField } from '../TemplateFormFilePickerField';
import { TemplateFormFilePickerFieldMetaProps } from '../interfaces/template-form-file-picker-field-meta';

export const TemplateFormFilePickerFieldMeta: TemplateFormComponentMeta<
  TemplateFormFilePickerFieldMetaProps,
  {
    metadata_configuration?: {
      [key: string]: string;
    };
  }
> = {
  component: TemplateFormFilePickerField,
  MetadataFactory: (field, disableEdit) => ({
    dataId: `template-form-${field.name}`,
    fieldName: field.name,
    label: DOMPurify.sanitize(field.display_name ?? ''),
    className: getTemplateFormGridColumnSpan(field.size),
    helperText: TemplateFormHelperText({ helperText: field.helper_text, fieldName: field.name }),
    disabled: disableEdit || !!field.disabled
  }),
  ValidationSchemaFactory: field => TemplateFormFieldValidationsFactory(field, Yup.string())
};
